module.exports = __webpack_public_path__ + "img/hamamoto-san.5f180f24.jpg";